<template>
  <div class="alerts">
    <div class="header-mobile show-medium">
      <div class="filter-expander" @click="openFilter">
        {{ $t('filters') }}
        <div class="expand-container">
          <div class="expand"></div>
        </div>
      </div>
      <div class="link-button" @click="resetFilters">
        {{ $t('resetFilters') }}
      </div>
    </div>

    <div
      class="container no-scroll-bar"
      :class="{
        'hide-mobile': !showFilter,
      }"
    >
      <div class="filter-header show-medium">
        <div class="title">
          {{ $t('filters') }}
        </div>
        <div class="close-button cross inverse" @click="closeFilter" />
      </div>

      <div class="filter-footer show-medium">
        <div class="main-button" @click="closeFilter">
          {{ $t('search') }}
        </div>
      </div>

      <div class="form-container">
        <div class="input-title">{{ $t('period') }}</div>
        <Dropdown
          class="year-dropdown"
          :config="{ inputSize: 48, color: 'white', active: false }"
          :values="getYear()"
          :placeholder="$t('period')"
          :on-change="
            value => {
              selectedYear = value;
            }
          "
          :value="selectedYear"
        >
          <template #placeholder="{ value, isPlaceholder }">
            <div v-if="!isPlaceholder" class="value">{{ value }}</div>
            <div v-else class="value grey">{{ value }}</div>
          </template>
          <template #choices="{ choice }">
            <div class="value black" :class="{ highlight: choice === selectedYear }">{{ choice }}</div>
          </template>
        </Dropdown>
      </div>
      <div class="form-container">
        <div class="input-title">{{ $t('statut') }}</div>
        <Dropdown
          class="status-dropdown"
          :config="{ inputSize: 48, color: 'white', active: false }"
          :values="[$t('read'), $t('unread')]"
          :placeholder="$t('allStatutes')"
          :on-change="value => (isRead = value)"
          :value="isRead"
        >
          <template #placeholder="{ value, isPlaceholder }">
            <div v-if="!isPlaceholder" class="value">{{ value }}</div>
            <div v-else class="value grey">{{ value }}</div>
          </template>
          <template #choices="{ choice }">
            <div class="value black" :class="{ highlight: choice === selectedYear }">{{ choice }}</div>
          </template>
        </Dropdown>
      </div>
    </div>

    <div class="header hide-small">
      <div class="link-button reset-button" @click="resetFilters">{{ $t('resetFilters') }} <ResetIcon class="icon-reset" /></div>
      <div class="main-button">{{ $t('exportAlerts') }}</div>
    </div>

    <!-- <div class="container alert"> -->
    <AlertsTable
      :users="users"
      :packages="packages"
      :config="{
        pagination: true,
        maxElement: 10,
        internalUserOnly: true,
        companySiren: $route.params.id,
        headingFilters: { denomination: false, monitoringLevel: false, event: false, manager: false },
      }"
      :filters="{ isFiltered: true, year: selectedYear, isRead: isRead }"
    />
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Dropdown from '@/components/Dropdown';
import AlertsTable from '@/components/tables/AlertTable';

export default {
  components: { AlertsTable, Dropdown },

  props: {
    isMonitored: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isRead: '',
      selectedYear: 'Toutes',
      loaded: false,
      hightlight: 'alerts',
      packages: [],
      news: [],
      users: [],
      showFilter: false,
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  async mounted() {
    this.news = (await this.$store.dispatch('getNews')).items;
    this.users = (await this.$store.dispatch('getUsers', { id: this.user.client.id })).users;
    this.packages = (await this.$store.dispatch('getPackagesLevel')).items;
    this.loaded = true;
  },

  created() {
    if (!this.isMonitored) {
      this.$router.push({ name: 'searchByIdEnterprise', replace: true });
    }
  },

  methods: {
    openFilter() {
      this.showFilter = true;
      document.querySelector('.topbar').style.display = 'none';
    },

    closeFilter() {
      this.showFilter = false;
      document.querySelector('.topbar').style.display = 'flex';
    },

    goToAndRemoveAnchor(anchor, hightlight) {
      this.hightlight = hightlight;
      const url = location.href;
      location.href = '#' + anchor;
      history.replaceState(null, null, url);
    },

    resetFilters() {
      this.selectedYear = new Date().getFullYear();
      this.isRead = '';
    },

    getYear() {
      const array = [];
      for (let index = new Date().getFullYear() - 10; index < new Date().getFullYear() + 1; index++) {
        array.push(index);
      }
      array.push('Toutes');
      return array.reverse();
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.alerts {
  width: 100%;
  display: flex;
  padding: 12px 12px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .link-button {
      color: colors.$lightgrey-color;
    }

    .main-button {
      background: colors.$main-color;
    }
  }

  .container {
    display: flex;

    &.alert {
      margin-bottom: 315px;
    }

    .year-dropdown {
      width: 128px;
    }

    .status-dropdown {
      width: 256px;
    }

    .form-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-right: 8px;

      .year-dropdown {
        width: 128px;
      }

      .input-title {
        width: 100%;
        color: colors.$darkgrey-color;
        font-weight: 500;
        font-size: 16px;
        margin: 24px 0 10px 0;
      }
    }
  }

  .col {
    &.sub-sub-header {
      flex-grow: 1;
      width: 200px;
      max-height: 200px;
      padding-right: 36px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: sticky;
      top: 110px;

      .link {
        margin: 0 0 20px;
        font-weight: 500;
        font-size: 18px;
        color: colors.$grey-color;
        width: 100%;

        &.highlight {
          color: colors.$black-color;
        }

        &:hover {
          cursor: pointer;
          color: rgba(colors.$black-color, 0.8);
        }
      }
    }

    &.alerts-container {
      display: flex;
      padding-left: 80px;
      border-left: 1px solid colors.$lightgrey-color;
      width: 100%;
      flex-grow: 1;
      flex-direction: column;

      .title {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 20px;
        margin: 0 0 24px;

        &:not(:first-child) {
          padding-top: 80px;
        }
      }
    }
  }
}

.header-mobile {
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: space-between;

  .filter-expander {
    display: flex;
    flex-direction: row;

    align-items: center;
  }

  .expand-container {
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;

    &:hover {
      cursor: pointer;

      .expand {
        transform: rotate(45deg) scale(1.15);
      }
    }

    .expand {
      border: 2px solid colors.$text-color;
      border-left: none;
      border-top: none;
      width: 7px;
      height: 7px;
      transform: rotate(45deg);
      transition: all 0.2s;
    }

    &.active {
      .expand {
        transform: rotate(225deg);
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .view .header-search {
    padding-bottom: 32px;
  }

  .alerts {
    padding: 36px 12px 36px !important;
  }

  .filter-header {
    width: 100%;
    height: 64px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    border-bottom: 1px solid #e1e5ea;

    .title {
      font-weight: 500;
      font-size: 20px;
      line-height: 23px;
      color: #1c236b;
    }
  }

  .filter-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 64px;
    padding: 12px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(210, 218, 228, 0.7);

    .main-button {
      background: colors.$green-color !important;
    }
  }

  // .content {
  //   width: 100%;
  //   overflow: hidden;

  .header-content {
    .input-container {
      margin-right: 0;
    }

    .main-button {
      display: none;
    }
  }

  .container {
    position: fixed;
    top: 0;
    z-index: 100000;
    background: white;
    padding-top: 80px;
    left: 0;
    right: 0;
    height: 100vh;
    flex-direction: column;
    align-items: end;
    padding: 0 16px;
    justify-content: flex-start !important;

    &.hide-mobile {
      display: none;
    }
  }

  .form-container {
    width: 100%;
    margin-right: 0 !important;

    &.search {
      flex-grow: 0 !important;
    }

    .input-title {
      margin-top: 10px !important;
    }
  }

  .dropdown-container {
    width: 100% !important;
  }
  // }
}
</style>
